import { useState } from "react";
import { todayCategories, todayFeed } from "@/mocks/chigua";

export default function TodayFeed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? todayFeed : todayFeed.filter((it) => it.category === active);
  const feature = list.find((it) => it.isTop) ?? list[0];
  const rest = list.filter((it) => it.id !== feature?.id);

  return (
    <section id="today" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
            <i className="ri-flashlight-fill"></i> 实时 · 短讯速递
          </span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜福利今日更新
            <span className="ml-2 rounded-md bg-accent-100 px-2 py-0.5 text-sm font-medium text-accent-700">抢先看</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按最新发布时间排列的热讯，短而精，随时刷随时有新进展。
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-100 p-1 border border-background-200 md:self-auto">
          {todayCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`rounded-full px-3 py-1.5 text-sm whitespace-nowrap transition-colors ${
                active === cat
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-200"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {feature && (
        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-[0.9fr_1.6fr]">
          <div className="rounded-lg bg-accent-500 p-5 text-background-50 md:p-6">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-2.5 py-1 text-xs whitespace-nowrap">
                <i className="ri-star-fill text-xs"></i> 置顶焦点
              </span>
              <span className="text-xs text-background-50/80 whitespace-nowrap">{feature.time}</span>
            </div>
            <h3 className="mt-5 text-xl font-bold leading-snug md:text-2xl">{feature.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-50/85">{feature.excerpt}</p>
            <a
              href="#latest"
              className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-accent-700 whitespace-nowrap"
            >
              查看详情 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {rest.map((item) => (
              <div
                key={item.id}
                className="flex flex-col rounded-lg bg-background-100 p-4 border border-background-200 transition-colors hover:border-accent-300 hover:bg-background-50"
              >
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-200 px-2 py-0.5 text-[11px] text-secondary-900 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400">{item.category}</span>
                </div>
                <a href="#latest" className="mt-2.5 text-sm font-medium leading-snug text-foreground-950 hover:text-primary-600">
                  {item.title}
                </a>
                <div className="mt-auto flex items-center gap-3 pt-3 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-fill text-primary-500"></i> {item.heat}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line"></i> {item.time}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}